//
// Checkbox
//
import React from 'react'

import BooleanBase from './_bases/BooleanBase'

const Boolean01 = (props) => (
  <BooleanBase id='boolean-01-select' mb={['24px', null, '30px']} {...props} />
)

export default Boolean01
